import report from "@/http/requests/Report"

export default {
      async getAllLoginFailuresReport(context, { startAt, finishAt, selectedUsers }) {
        try {
          let response = await report.getAllLoginFailuresReport(startAt, finishAt, selectedUsers);
          context.commit('setReports', { reports: response });
        } catch (Exception) {
          console.log(Exception);
          context.commit('setReports', { reports: [] });
        }
      },
}